import { loadStripe, Stripe } from '@stripe/stripe-js';

// Stripe publishable key - should be in environment variables
const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51Sb5ANBsHHG5sTu7hLGarQVLUqxEtlkAxI1Up11Hz3FtrxvJk6k3jpkLsqO4l8dQGmbfZWiJHuYKwFy6QWjn0NND00pyeUQMAF';

let stripePromise: Promise<Stripe | null>;

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};

// Subscription plan price IDs
export const SUBSCRIPTION_PLANS = {
  REBEL: 'price_1ScTGBBsHHG5sTu7iWItiSSW', // $1/month
  STANDARD: 'price_1ScTIDBsHHG5sTu7yj9kSTYd' // $599/month
};

export const PLAN_DETAILS = {
  [SUBSCRIPTION_PLANS.REBEL]: {
    name: 'Central Core+ Rebel',
    price: 1.00,
    interval: 'month',
    description: 'Rebel plan for testing'
  },
  [SUBSCRIPTION_PLANS.STANDARD]: {
    name: 'Central Core+',
    price: 599.00,
    interval: 'month',
    description: 'Standard plan for production gyms'
  }
};

